export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:created', () => {
    const { userAgent } = useDevice()
    const isNativeApp = useState(StateKey.IsNativeApp, () => false)
    isNativeApp.value = /Lottocom_app/.test(userAgent!)
  })
})
